import React from "react";

const ReportCard = ({ title, titleColor = "#1F384C", value }) => {
  return (
    <div
      className="rounded-2xl shadow-md pl-[24px] py-[16px] bg-white relative "
      style={{
        maxWidth: 235,
        flexGrow: 1,
        backgroundColor: "#FFFFFF",
        height: 112,
      }}
    >
      {/* Header */}
      <div className="flex flex-col h-[86px] justify-between">
        <div className="flex justify-start items-center gap-2 mb-2">
          <span
            className="inter-semibold text-sm"
            style={{ color: titleColor }}
          >
            {title}
          </span>
        </div>

        {/* Value */}
        <div
          className="inter-semibold text-2xl text-[#1C1C1C]"
          style={{ textAlign: "left" }}
        >
          {value}
        </div>
      </div>
    </div>
  );
};

export default ReportCard;
